<div class="modal-header">
  <h4 id="reject-item-modal" class="modal-title">
    {{ "Reject" | translate }}: {{ equipmentItemService.getName$(equipmentItem) | async }}
  </h4>

  <button (click)="cancel()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <div class="alert alert-warning">
    <p>
      <ng-container *ngIf="rejectWarningMessage"> <span [innerHTML]="rejectWarningMessage"></span>&nbsp; </ng-container>
      <span [innerHTML]="consultHandbookMessage"></span>
    </p>
  </div>

  <button (click)="cancel()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="!form.valid"
    (click)="reject()"
    class="btn btn-danger"
    type="button"
  >
    {{ "Reject" | translate }}
  </button>
</div>
